<div class="form-modal">
  <div class="form-modal__body">
    <div class="img-wrapper">
      <div class="title-wrapper">
        <h1>{{ isEditing ? 'Edit' : isNew ? 'Create New' : 'View' }} Template</h1>
      </div>
      <div class="close-button" (click)="onClose()">
        <i class="fa fa-times"></i>
      </div>
    </div>

    <form [formGroup]="templateForm" (ngSubmit)="onSubmit()" class="template-form">
      <div class="form-wrapper-80">
        <div class="form-group org-type-group">
          <span class="required">*</span><label class="org-type-label">Organization Type:</label>
          <div class="org-type-radio-group">
            <label class="app-c-radio" *ngFor="let org of organizationTypes">
              <input
                type="radio"
                formControlName="OrgType"
                [value]="org.id"
                [disabled]="isViewMode()" />
              <span>{{ org.name }}</span>
            </label>
          </div>
        </div>

        <div class="app-c-form-group title-row">
          <label class="app-c-form--label" for="title"><span class="required">*</span>Title:</label>
          <input
            class="app-c-form-control"
            [readonly]="isViewMode()"
            id="title"
            formControlName="Title"
            placeholder="Template Title"
            type="text"
            [ngClass]="{'invalid': templateForm.get('Title')?.invalid && (templateForm.get('Title')?.touched || submitButtonPressed)}" />
          <div *ngIf="templateForm.get('Title')?.invalid && (templateForm.get('Title')?.touched || submitButtonPressed)" class="error-message">
            Title is required.
          </div>
        </div>

        <div class="app-c-form-group">
          <label class="app-c-form--label" for="content"><span class="required">*</span>Content:</label>
          <ckeditor [editor]="Editor" id="content" [readonly]="isViewMode()" formControlName="Content" [config]="config"></ckeditor>
          <div *ngIf="templateForm.get('Content')?.invalid && (templateForm.get('Content')?.touched || submitButtonPressed)" class="error-message">
            Content is required.
          </div>
        </div>

        <div class="app-c-form-group">
          <label class="app-c-form--label" for="link"><b>Optional:</b> Select the Content to Link in Message</label>
          <select
            class="app-c-form-control"
            id="link"
            [attr.disabled]="isViewMode() ? '' : null"
            formControlName="Link"
            (change)="onLinkSelect($any($event.target).value)">
            <option value="">None</option>
            <option *ngFor="let link of linkOptions" [value]="link">{{ link }}</option>
          </select>
        </div>

        <div class="fixed-footer">
          <a tabindex="0" class="app-c-btn app-c-btn--primary app-c-btn--curve" (click)="onSubmit()" (keypress)="onSubmit()">
            {{ isEditing ? 'Update Template' : isNew ? 'Add Template' : 'Close' }}
          </a>
        </div>
      </div>
    </form>
  </div>
</div>
